import { render, staticRenderFns } from "./AttendanceLogs.vue?vue&type=template&id=e4d32c06"
import script from "./AttendanceLogs.vue?vue&type=script&lang=js"
export * from "./AttendanceLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports